module.exports = __webpack_public_path__ + "img/image_wedding.d2f62491.jpg";